import { INSTANT_SEARCH_EXPIRED_SESSION_ERROR } from './constants';

type InstantSearchErrorProps = {
  body: string;
  instantSearchError: string;
  message: string;
};

const InstantSearchError = ({
  message,
  body,
  instantSearchError,
}: InstantSearchErrorProps) => {
  if (instantSearchError === INSTANT_SEARCH_EXPIRED_SESSION_ERROR) {
    return (
      <div className="ch-ph--2 ch-text--center ch-mt--3 sm:ch-mt--n1">
        <h1 className="ch-fs--3 sm:ch-fs--4">{message}</h1>
        <p className="ch-fs--2 ch-mb--0 ch-measure ch-mh--auto sm:ch-width--8">
          {body}
        </p>
        <button
          className={
            'ch-btn ch-btn--secondary ch-width--12 sm:ch-width--6 ch-mt--4'
          }
          onClick={() => window.location.reload()}
          type="button"
        >
          Refresh
        </button>
      </div>
    );
  }

  return (
    <div className="ch-alert ch-alert--danger ch-alert--icon ch-fs--3">
      <p className="ch-fw--500 ch-mb--1">{message}</p>
      <p className="ch-mb--0">{body}</p>
    </div>
  );
};

export default InstantSearchError;
